import React from 'react';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';

// 首屏：AixueHome 内容
export default function Screen1() {
  return (
    <section className={`${styles['screen1-cover']}`}>
      {/* 头部导航 */}
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      {/* 内容区域 */}
      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
            <div
              className={`wow animate__animated animate__fadeIn ${styles['screen1-title']}`}
              style={{ animationDelay: '0.2s', animationDuration: '1.2s' }}
            >
              <strong className="visibility-hidden opacity-0">AI学就爱学</strong>
              <strong className="visibility-hidden opacity-0">你的专属AI一对一导师</strong>
            </div>
        </div>
      </div>
    </section>
  );
}
